import { ANDROID_PACKAGE_NAME, IOS_APP_STORE_ID } from '@/config/sharing-links';

export const EXT_LINK_IOS_APP = `https://apps.apple.com/app/keakie/id${ IOS_APP_STORE_ID }`;
export const EXT_LINK_ANDROID_APP = `https://play.google.com/store/apps/details?id=${ ANDROID_PACKAGE_NAME }`;
export const EXT_LINK_ABOUT = 'https://about.keakie.com';
export const EXT_LINK_INSTAGRAM = 'https://www.instagram.com/keakiemusic';
export const EXT_LINK_NEWSROOM = 'https://newsroom.keakie.com';